var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 1.00079H2.25C1.91848 1.00079 1.60054 1.13249 1.36612 1.36691C1.1317 1.60133 1 1.91927 1 2.25079V9.75079C1 10.0823 1.1317 10.4003 1.36612 10.6347C1.60054 10.8691 1.91848 11.0008 2.25 11.0008H9.75C10.0815 11.0008 10.3995 10.8691 10.6339 10.6347C10.8683 10.4003 11 10.0823 11 9.75079V7.25079M6 6.00079L11 1.00079M11 1.00079V4.12579M11 1.00079H7.875",
    stroke: "#FF0000",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTab);
export default __webpack_public_path__ + "static/media/tab.e8dba030dd1a514b4dc172accc554cbc.svg";
export { ForwardRef as ReactComponent };